import Vue from "vue";
import App from "./App.vue";
import BootstrapVue from "bootstrap-vue";
import Vuesax from "vuesax";
import Router from "vue-router";
import routes from "./routes";
import "vuesax/dist/vuesax.css"; //Vuesax styles
import "bootstrap/dist/css/bootstrap.css"; //Bootstrap styles
import "bootstrap-vue/dist/bootstrap-vue.css"; //Bootstrap-vue styles
import "selectize/dist/css/selectize.bootstrap3.css";
import VueTagsInput from "@johmun/vue-tags-input";
import VueFormWizard from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import "material-icons/iconfont/material-icons.css";
import Avatar from "vue-avatar-component";
import moment from "moment";
import VueInputMask from "vue-inputmask";
import VueHtmlToPaper from 'vue-html-to-paper';
import toast from "./toast";
// import { timers } from "jquery";

const options = {
    name: '_blank',
    specs: [
      'fullscreen=yes',
      'titlebar=yes',
      'scrollbars=yes'
    ],
    styles: [
      'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
      'https://unpkg.com/kidlat-css/css/kidlat.css',
      '/style.css'
    ]
  }
  Vue.use(VueHtmlToPaper, options);
// Add support for input mask
Vue.use(VueInputMask.default);

Vue.use(Vuesax);
Vue.use(toast);

Vue.use(Router);
Vue.use(VueFormWizard);
Vue.use(Avatar);

const router = new Router({ routes });

Vue.use(BootstrapVue);
Vue.use(VueTagsInput);

Vue.config.productionTip = false;
// This will show date/time in formatted form
Vue.filter("formatDate", function (value) {
    if (value) {
        return moment(String(value)).format("MM/DD/YYYY");
    }
});
Vue.filter("JSON", function (value) {
    if (value) {
        return JSON.stringify(value);
    }
});
Vue.filter("formatTime", function (value) {
    if (value) {
        return moment(String(value)).format("hh:mm:ss a");
    }
});
Vue.filter("formatDateTime", function (value) {
    if (value) {
        return moment(String(value)).format("MM/DD/YYYY hh:mm a");
    }
});
export const bus = new Vue();

Vue.use(router);
let isFirstTransition = true;
router.beforeEach((to, from, next) => {
    const lastRouteName = localStorage.getItem('LS_ROUTE_KEY');
      const shouldRedirect = Boolean(
        to.fullPath === "/"
        && lastRouteName
        && isFirstTransition
      );   
      if (shouldRedirect) {
        return next(lastRouteName);
      }
      else {
        next();
      } 
      isFirstTransition = false;
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (localStorage.getItem("token") == null) {
            next({
                path: "/",
                params: { nextUrl: to.fullPath }
            });
        }else {
            let user = JSON.parse(localStorage.getItem("currentUser"));
           
            if (to.meta.isPermission == "admin") {
                if (
                    user &&
                    (user.roles.permission == "admin" ||
                        user.roles.permission == "admin_officer" ||
                        user.roles.permission == "admin_expert" ||
                        user.roles.permission == "admin_associate" ||
                        user.roles.permission == "admin_assistant")
                ) {
                    next()
                } else {
                    next({ path: '/'})
                } 
            } else if(to.meta.isPermission == "advisor"){
                 if (user && user.roles.permission == "advisor") {
                    next()
                 } else {
                     next({path: '/'})
                 }
            } else if(to.meta.isPermission == "program_officer"){
                 if (
                    user &&
                    (user.roles.permission == "program_officer" ||
                        user.roles.permission == "program_assistant" ||
                        user.roles.permission == "program_coordinator" ||
                        user.roles.permission == "program_associate")
                ) {
                    next()
                } else {
                    next({path:'/'})
                }
            } else if(to.meta.isPermission == "trainer"){
                 if (user && user.roles.permission == "trainer") {
                    next()
                 } else {
                     next({path: '/'})
                 }
            } else if(to.meta.isPermission == "trainee"){
                if (user && user.roles.permission == "trainee") {
                    next()
                } else {
                    next({path: '/'})
                }
            } else if(to.meta.isPermission == "comm_officer"){
                 if (user && user.roles.permission == "comm_officer") {
                    next()
                 } else {
                     next({path: '/'})
                 }
            } else if(to.meta.isPermission == "country_represent"){
                 if (user && user.roles.permission == "country_represent") {
                    next()
                 } else {
                     next({path: '/'})
                 }
            } else {
                next({ path: "/", params: { nextUrl: to.fullPath } });
            }
        }
    } else {
        next();
    }
   
});

router.afterEach(to => {
var someString = to.fullPath;
someString = someString.replace(/^\/|\/$/g, "");
  localStorage.setItem('LS_ROUTE_KEY',someString );
//   localStorage.setItem('LS_LAST_ACTIVITY_AT_KEY', Date.now());
});
new Vue({
    router,
    render: h => h(App)
}).$mount("#app");